import React, { useEffect, useRef, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { common, mergeGridOpts } from 'utils/agGrid/options';

interface MarginProfileMultipliers {
  marginProfile: string;
  product: string;
  initialMarginRateMultiplier: string;
  maintenanceMarginRateMultiplier: string;
  maxInitialMarginRate: string;
  minInitialMarginRate: string;
  maxMaintenanceMarginRate: string;
  minMaintenanceMarginRate: string;
  spreadsMaxInitialMarginRate: string;
  spreadsMaxMaintenanceMarginRate: string;
  spreadsMinInitialMarginRate: string;
  spreadsMinMaintenanceMarginRate: string;
  publicName: string;
  publishToWebsite: string;
}

interface MarginProfileMultipliersFileGridProps {
  data: MarginProfileMultipliers[];
  colDefs: ColDef[];
  loading?: boolean;
}

const gridOpts = mergeGridOpts(common, {
  autoSizeStrategy: { type: 'fitCellContents' },
});
export const gridName = 'margin-profile-multipliers';

const MarginProfileMultipliersGrid: React.FC<
  MarginProfileMultipliersFileGridProps
> = ({ data, loading, colDefs }) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<MarginProfileMultipliers[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated, gridButtons } =
    useAgGridCommon({
      gridName,
      gridRef,
    });

  useEffect(() => {
    setRowData(data);
    if (!initialGridSettings?.columnSizing) {
      gridRef.current?.api?.sizeColumnsToFit();
    }
  }, [data, initialGridSettings?.columnSizing]);

  return (
    <div className="ag-theme-quartz">
      {gridVisible && (
        <>
          {gridButtons}
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            gridOptions={gridOpts}
            onStateUpdated={onStateUpdated}
            initialState={initialGridSettings}
            loading={loading}
          />
        </>
      )}
    </div>
  );
};

export default MarginProfileMultipliersGrid;
